import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { html, LpButton, LpDropdownMenu, LpIcon, } from "~/design-system";
import { getThemeToggleTarget, THEME, store, } from "~/state/store";
export class appHeader_template extends vnTemplate {
    getTemplateHtml() {
        return /* html */ `
            <!--<h2 class="page-title logo">
                <span class="prop-title" data-bind="text: brandName"></span>
                <span data-bind="text: headerTitle"></span>
            </h2>-->

            <button
                class="menu-toggle"
                data-bind="
                    click: onToggleMobileMenu,
                    attr: { 'data-expanded': isMobileMenuOpen() ? '' : null }
                "
            >
                <span class="menu-toggle_indicator">
                    <span class="line" data-position="top"></span>
                    <span class="line" data-position="bottom"></span>
                </span>
            </button>

            <div class="navigation-group">
                <nav
                    class="navigation-breadcrumbs"
                    aria-label="Breadcrumb"
                    data-bind="visible: breadcrumbs().length > 0"
                >
                    <ol class="navigation-breadcrumbs__list" data-bind="foreach: breadcrumbs">
                        <li class="navigation-breadcrumbs__item">
                            <!-- ko if: $data.href -->
                                <a class="navigation-breadcrumbs__link" data-bind="attr: { href: $data.href }">
                                    ${this.getBreadcrumbContentHtml()}
                                </a>
                            <!-- /ko -->
                            <!-- ko ifnot: $data.href -->
                                <span class="navigation-breadcrumbs__current">
                                    ${this.getBreadcrumbContentHtml()}
                                </span>
                            <!-- /ko -->
                            <!-- ko if: $index() < $parent.breadcrumbs().length - 1 -->
                                <span class="navigation-breadcrumbs__separator" aria-hidden="true">›</span>
                            <!-- /ko -->
                        </li>
                    </ol>
                </nav>

                <div class="navigation-group__right">
                    <a href="/home" class="navigation-link">Dashboard</a>

                    <div class="navigation-actions">
                        ${this.getThemeButtonHtml(THEME.dark)}
                        ${this.getThemeButtonHtml(THEME.light)}
                        ${this.getThemeButtonHtml(THEME.system)}

                        <!-- ko if: isSettingsVisible -->
                            ${this.getSettingsMenuHtml()}
                        <!-- /ko -->

                        <!-- ko if: user() -->
                            ${this.getUserMenuHtml()}
                        <!-- /ko -->
                    </div>
                </div>
            </div>
        `;
    }
    getTemplateName() {
        return "appHeader-template";
    }
    getBreadcrumbContentHtml() {
        return `
            <!-- ko if: $data.icon === 'home' -->
                ${LpIcon({ name: "house", size: 16, className: "navigation-breadcrumbs__icon" })}
            <!-- /ko -->
            <span data-bind="text: $data.label"></span>
        `;
    }
    getMainElementClasses() {
        return ["app-header", "t__appHeader"];
    }
    buildViewModel() {
        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        const currentTheme = ko.observable(store.getState().theme);
        const isMobileMenuOpen = ko.observable(store.getState().isMobileMenuOpen);
        const viewModel = {
            currentTheme,
            isMobileMenuOpen,
            onToggleTheme: function () {
                huit_neuf_this.toggleTheme();
            },
            onToggleMobileMenu: function () {
                huit_neuf_this.toggleMobileMenu();
            },
        };
        return {
            ...viewModel,
            user: ko.observable(null),
            breadcrumbs: ko.observableArray([]),
            headerTitle: ko.observable(""),
            brandClass: ko.observable(""),
            brandName: ko.observable(""),
            isUserStatsVisible: ko.observable(false),
            isRolesVisible: ko.observable(false),
            isLogsVisible: ko.observable(false),
            isUsersVisible: ko.observable(false),
            isTasksVisible: ko.observable(false),
            isSettingsVisible: ko.observable(false),
            onClickLogOutAction: function (data, event) {
                huit_neuf_this.onClickLogOutAction();
            },
            onclickViewProfile: function (idUser) {
                huit_neuf_this.onClickViewProfile(idUser);
            },
        };
    }
    setTheme(theme) {
        this.getTemplateViewModel().currentTheme(theme);
    }
    setMobileMenuOpen(isOpen) {
        this.getTemplateViewModel().isMobileMenuOpen(isOpen);
    }
    setSidebarState(sidebarState) {
        this.builtTemplate?.setAttribute("data-sidebar", sidebarState);
    }
    setIsUserStatsVisible(isUserStatsVisible) {
        this.viewModel[this.idElement].isUserStatsVisible(isUserStatsVisible);
    }
    setIsLogsVisible(isLogsVisible) {
        this.getTemplateViewModel().isLogsVisible(isLogsVisible);
    }
    setIsUsersVisible(isUsersVisible) {
        this.getTemplateViewModel().isUsersVisible(isUsersVisible);
    }
    setHeaderTitle(title) {
        this.getTemplateViewModel().headerTitle(title);
    }
    setBreadcrumbs(breadcrumbs) {
        this.getTemplateViewModel().breadcrumbs(breadcrumbs);
    }
    setBrandClass(brandClass) {
        this.getTemplateViewModel().brandClass(brandClass);
    }
    setBrandName(brandName) {
        this.getTemplateViewModel().brandName(brandName);
    }
    setIsRolesVisible(isRolesVisible) {
        this.viewModel[this.idElement].isRolesVisible(isRolesVisible);
    }
    onClickLogOutAction() {
        this.caller.logOut();
    }
    onClickViewProfile(idUser) {
        this.caller.viewProfile(idUser);
    }
    toggleTheme() {
        store.getState().toggleTheme();
    }
    toggleMobileMenu() {
        store.getState().toggleMobileMenu();
    }
    getThemeButtonHtml(theme) {
        return `
            <!-- ko if: currentTheme() === '${theme}' -->
                ${LpButton({
            ariaLabel: this.getThemeToggleLabel(theme),
            prefixIcon: this.getThemeIconName(theme),
            variant: "ghost",
            size: "sm",
            shape: "square",
            className: "app-header__control",
            attributes: {
                "data-bind": "click: onToggleTheme",
                title: this.getThemeToggleLabel(theme),
            },
        })}
            <!-- /ko -->
        `;
    }
    getThemeIconName(theme) {
        const iconNames = {
            [THEME.dark]: "moon",
            [THEME.light]: "sun",
            [THEME.system]: "circle-half",
        };
        return iconNames[theme];
    }
    getThemeToggleLabel(theme) {
        return `Switch to ${getThemeToggleTarget(theme)} mode`;
    }
    getSettingsMenuHtml() {
        return String(LpDropdownMenu.Root({
            trigger: (context) => LpDropdownMenu.Trigger({
                ...context,
                ariaLabel: "Settings",
                prefixIcon: "gear",
                variant: "ghost",
                size: "sm",
                shape: "square",
                className: "app-header__control",
            }),
            content: (context) => LpDropdownMenu.Content({
                ...context,
                align: "end",
                label: "Settings",
                children: html `
                    <!-- ko if: isUsersVisible -->
                        ${LpDropdownMenu.LinkItem({ label: "Users", href: "/users" })}
                    <!-- /ko -->
                    <!-- ko if: isLogsVisible -->
                        ${LpDropdownMenu.LinkItem({ label: "Logs", href: "/logs" })}
                    <!-- /ko -->
                    <!-- ko if: isTasksVisible -->
                        ${LpDropdownMenu.LinkItem({ label: "Tasks", href: "/tasks" })}
                    <!-- /ko -->
                    <!-- ko if: isRolesVisible -->
                        ${LpDropdownMenu.LinkItem({ label: "Roles", href: "/roles" })}
                    <!-- /ko -->
                `,
            }),
        }));
    }
    getUserMenuHtml() {
        return String(LpDropdownMenu.Root({
            trigger: (context) => LpDropdownMenu.Trigger({
                ...context,
                ariaLabel: "User menu",
                prefixIcon: "user-circle",
                prefixIconWeight: "fill",
                variant: "ghost",
                size: "sm",
                shape: "square",
                className: "app-header__control",
            }),
            content: (context) => LpDropdownMenu.Content({
                ...context,
                align: "end",
                label: "User menu",
                children: LpDropdownMenu.Group({
                    children: (groupContext) => html `
                        ${LpDropdownMenu.Label({
                        ...groupContext,
                        children: html `
                                <span class="app-header__user-identity">
                                    <span
                                        class="app-header__user-name"
                                        data-bind="text: user().user.valnet_user.fullName"
                                    ></span>
                                    <span
                                        class="app-header__user-email"
                                        data-bind="text: user().user.valnet_user.email"
                                    ></span>
                                </span>
                            `,
                    })}
                        ${LpDropdownMenu.Item({
                        label: "Your Profile",
                        attributes: {
                            "data-bind": "click: function() { onclickViewProfile(user().user.id) }",
                        },
                    })}
                        ${LpDropdownMenu.Separator()}
                        ${LpDropdownMenu.Item({
                        label: "Log out",
                        variant: "danger",
                        attributes: {
                            "data-bind": "click: onClickLogOutAction",
                        },
                    })}
                    `,
                }),
            }),
        }));
    }
    setUser(user) {
        this.getTemplateViewModel().user(user);
    }
}
